const initialState = {
  resultsSubscriptionsList: [],
  resultsSubscription: {},
  resultsSubscriptionAdd: {},
  resultsSubscriptionEdit: {},
  resultsSubscriptionDelete: {}
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_SUBSCRIPTION_RESPONSE_GET":
      newState.resultsSubscriptionsList = action.value;
      break;
    case "SUBSCRIPTION_RESPONSE_GET":
      newState.resultsSubscription = action.value;
      break;
    case "SUBSCRIPTION_RESPONSE_RESET":
      newState.resultsSubscription = {};
      break;
    case "SUBSCRIPTION_RESPONSE_ADD":
      newState.resultsSubscriptionAdd = action.value;
      break;
    case "SUBSCRIPTION_RESPONSE_EDIT":
      newState.resultsSubscriptionEdit = action.value;
      break;
    case "SUBSCRIPTION_RESPONSE_DELETE":
      newState.resultsSubscriptionDelete = action.value;
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
